export default "__VITE_ASSET__f21691c7__"